<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs2 md2>
        <v-btn color="primary" dark text @click="showRectifierDialog(true)"
          >新增商品</v-btn
        >
      </v-flex>
      <v-flex xs3 md2>
        <v-btn color="primary" dark text @click="showProductTypeDialog()"
          >新增整流器機種代號</v-btn
        >
      </v-flex>
      <v-flex xs2 md2>
        <v-btn color="primary" dark text @click="ecuManageDialog()"
          >管理ECU群組列表</v-btn
        >
      </v-flex>
    </v-layout>

    <!-- <v-layout  mt-2>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.endDate" />
      </v-flex>
    </v-layout> -->

    <v-layout mt-2>
      <v-flex xs4 md2 pr-3>
        <v-select
          :items="typeKeys"
          item-text="value"
          item-value="key"
          v-model="typeStatus"
          @change="changeTypeStatus()"
        ></v-select>
      </v-flex>
      <v-flex md2 xs8>
        <v-select
          :items="searchKeys"
          item-text="value"
          item-value="key"
          v-model="search.searchKey"
          label="查詢條件"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md5 xs8 v-if="search.searchKey === `vendor`">
        <v-select
          :items="vendorList"
          item-text="value"
          item-value="key"
          v-model="search.keyword"
          label="搜尋廠商"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md5 xs8 v-else-if="search.searchKey === `cc`">
        <v-select
          :items="ccSearchKeys"
          item-text="value"
          item-value="key"
          v-model="search.keyword"
          label="搜尋cc數範圍"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md5 xs8 v-else>
        <v-text-field
          v-model="search.keyword"
          :label="`搜尋車名`"
          :placeholder="search.placeholder"
          @keyup.enter="searchEvent"
        ></v-text-field>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <table-view
        :columnKeys="columnKeys"
        :items="items"
        :loading="loading"
        :total-items="totalItems"
        @changePage="changePage"
        @cellEvent="cellEvent"
        @handleLoadData="reset"
      >
      </table-view>
    </v-layout>
    <!--彈出視窗-->
    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :isHtmlContent="true"
      :showCancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    ></alert-view>

    <rectifier-edit-dialog
      :visible="rectifierDialog.visible"
      :title="rectifierDialog.title"
      :item="rectifierDialog.item"
      :categoryList="
        rectifierDialog.item.type === 0 ? categoryList : ecuCategoryList
      "
      :typeList="typeKeys"
      :groupList="groupList"
      @confirmEvent="editRectifier"
      @cancelEvent="rectifierDialog.cancel"
    ></rectifier-edit-dialog>

    <product-type-dialog
      :visible="productTypeDialog.visible"
      :title="productTypeDialog.title"
      @confirmEvent="productTypeDialog.confirm"
      @cancelEvent="productTypeDialog.cancel"
    ></product-type-dialog>
    <ecu-manage-dialog
      :visible="ecuDialog.visible"
      :title="ecuDialog.title"
      @confirmEvent="ecuDialog.confirm"
    ></ecu-manage-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileDetect from "mobile-detect";

import AlertView from "@/components/AlertView";
import TableView from "@/components/TableView";
import { getCurrentDate } from "@/pages/utils/tool";
import DatePicker from "@/components/DatePicker";
import RectifierEditDialog from "@/components/RectifierEditDialog";
import RectifierModel from "../../models/RectifierModel";
import ProductTypeDialog from "@/components/ProductTypeDialog";
import EcuManageDialog from "@/components/EcuManageDialog";
import common from '../../mixins/common';

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "RectifierManagerView",
  components: {
    ProductTypeDialog,
    AlertView,
    TableView,
    DatePicker,
    RectifierEditDialog,
    EcuManageDialog,
  },
  mixins:[common],
  data() {
    return {
      loading: false,
      isMobile: md.phone(),
      isCreateInfo: false,
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      search: {
        keyword: "",
        placeholder: "搜尋名稱",
        startDate: "2021-01-01",
        endDate: "2121-01-01",
        searchKey: "carName",
      },
      items: [],
      typeStatus: 0,
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      rectifierDialog: {
        title: "",
        visible: false,
        item: new RectifierModel(),
        confirm: () => {},
        cancel: () => {},
      },
      productTypeDialog: {
        title: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      groupKeys: [],
      ecuDialog: {
        title: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  created() {
    this.loadData(this.pageIndex, this.limit);
    this.updateGroupList();
  },
  watch: {
    "search.searchKey"(value) {
      if (value === "carName") {
        this.search.keyword = "";
      }
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    columnKeys() {
      var list = [
        {
          value: "edit",
          text: "編輯",
          sortable: false,
          required: false,
          color: "primary",
          isEvent: true,
        },
        { value: "id", text: "商品型號", sortable: true, required: false },
        {
          value: "generalNumber",
          text: "機種代號",
          sortable: true,
          required: false,
        },
        {
          value: "vendor",
          text: "廠商",
          sortable: true,
          required: false,
          options: this.vendorList,
          isSelect: true,
        },
        { value: "cc", text: "C.C.數", sortable: true, required: false },
        { value: "carName", text: "車名", sortable: true, required: false },
        { value: "comment", text: "備註", sortable: true, required: false },
      ];

      if (this.typeSatus === 1) {
        list.push({
          value: "caliber",
          text: "口徑",
          sortable: true,
          required: false,
        });
        list.push({
          value: "engineNumber",
          text: "引擎號碼",
          sortable: true,
          required: false,
        });
      }

      // list.push({ value: "updateDate", text: "更新日期", sortable: true, required: false })
      list.push({
        value: "delete",
        text: "刪除",
        sortable: false,
        required: false,
        isEvent: true,
      });

      return list;
    },
    getTotalItems() {
      return this.totalItems;
    },
    groupList() {
      let array = [];
      this.groupKeys.forEach((element) => {
        array.push({ key: element.groupId, value: element.name });
      });
      return array;
    },
    categoryList() {
      return [
        { key: 0, value: "街道版" },
        { key: 1, value: "升級版" },
      ];
    },
    searchKeys() {
      return [
        { key: "vendor", value: "廠商" },
        { key: "cc", value: "cc數" },
        { key: "carName", value: "車名" },
      ];
    },
    typeKeys() {
      return [
        { key: 0, value: "整流器" },
        { key: 1, value: "ECU" },
      ];
    },
    ecuCategoryList() {
      return [
        { key: 0, value: "整新品" },
        { key: 1, value: "維修交換品" },
        { key: 2, value: "維修品" },
        { key: 3, value: "故障品" },
      ];
    },
    ccSearchKeys() {
      return [
        { key: 0, value: "不拘" },
        { key: 1, value: "0~100" },
        { key: 2, value: "101~200" },
        { key: 3, value: "201~300" },
        { key: 4, value: "301~400" },
        { key: 5, value: "401以上" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "motoDelete",
      "motoList",
      "motoUpdate",
      "motoCreate",
      "uploadImageData",
      "ecuList",
    ]),
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.search.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.search.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    changePage(page) {
      // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData(this.pageIndex, this.limit);
    },
    changeTypeStatus() {
      this.loadData(this.pageIndex, this.limit);
    },
    async loadData(pageIndex, limit, isExport = false) {
      this.loading = true;
      let searchQuery = [{ key: `type`, value: `${this.typeStatus}` }];
      if (this.search.searchKey && this.search.keyword) {
        searchQuery.push({
          key: `${this.search.searchKey}`,
          value: `${this.search.keyword}`,
        });
      }

      const data = {
        startDate: `${this.search.startDate} 00:00:00`,
        endDate: `${this.search.endDate} 23:59:59`,
        pageIndex: pageIndex,
        limit: limit,
        searchQuery: searchQuery,
      };
      console.log(`data === ${JSON.stringify(data)}`);
      const results = await this.motoList(data);

      this.items = results.data.data.list;
      console.log(`result === ${JSON.stringify(this.items)}`);
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
    },
    cellEvent(props) {
      // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`);
      if (props.key === "edit") {
        this.showRectifierDialog(false, props.item);
      }
      if (props.key === "delete") {
        this.deleteAlertView(props.item);
      }
    },
    exportData() {
      this.loadData(1, 10000, true);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    searchEvent() {
      this.loadData(this.pageIndex, this.limit);
    },
    reset() {
      this.search.keyword = "";
      this.loadData(this.pageIndex, this.limit);
    },
    showRectifierDialog(isNew, info = new RectifierModel()) {
      this.rectifierDialog.visible = true;
      this.rectifierDialog.item = info;
      let title = "機車商品";
      this.rectifierDialog.title = isNew ? `新增${title}` : `編輯${title}`;
      this.isCreateInfo = isNew;
      this.rectifierDialog.cancel = () => {
        this.rectifierDialog.visible = false;
      };
    },
    showProductTypeDialog() {
      this.productTypeDialog.visible = true;
      let title = "整流器機種代號";
      this.productTypeDialog.title = `編輯${title}`;
      this.productTypeDialog.cancel = () => {
        this.productTypeDialog.visible = false;
      };
      this.productTypeDialog.confirm = () => {
        this.productTypeDialog.visible = false;
        console.log(`save success`);
      };
    },
    ecuManageDialog() {
      this.ecuDialog.visible = true;
      let title = "ECU群組";
      this.ecuDialog.title = `${title}`;
      this.ecuDialog.confirm = () => {
        this.ecuDialog.visible = false;
        this.updateGroupList();
      };
    },
    async editRectifier(item) {
      if (item.imageList !== null && item.imageList.length > 0) {
        for (let file of item.imageList) {
          if (file.image && !file.url) {
            const urlPath = await this.uploadImageData({
              name: Math.uuidFast(),
              image: file.image,
            });
            file.url = urlPath;
          }
        }
      }

      let results = this.isCreateInfo
        ? await this.motoCreate(item)
        : await this.motoUpdate(item);

      this.rectifierDialog.visible = false;
      this.showMessageDialog("提示", results.data.message, true, () => {
        this.messageDialog.visible = false;
      });

      await this.loadData(this.pageIndex, this.limit);
    },
    async deleteAlertView(info) {
      this.messageDialog.showCancelButton = true;
      let message = `是否刪除此商品  ？`;
      this.showMessageDialog(
        "提示",
        message,
        true,
        () => {
          this.messageDialog.showCancelButton = false;
          this.messageDialog.visible = false;
          this.deleteEvent(info);
        },
        () => {
          this.messageDialog.showCancelButton = false;
          this.messageDialog.visible = false;
        }
      );
    },
    async deleteEvent(info) {
      let results = await this.motoDelete({
        productId: info.productId,
      });
      this.showMessageDialog("提示", results.data.message, true, () => {
        this.messageDialog.visible = false;
      });
      await this.loadData(this.pageIndex, this.limit);
    },
    async updateGroupList() {
      const results = await this.ecuList();
      this.groupKeys = results.data.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/web/RectifierManagerView.vue